/* eslint-disable react-hooks/exhaustive-deps */
import { Formik } from "formik";
import { useEffect, useState } from "react";
import InputFormik from "../../../../../components/InputFormik";
import Spinner from "../../../../../components/Spinner/index";
import useAuthData from "../../../../../hook/useAppData";
import useFormStore from "../store/useStore";
import "./index.scss";
import { serviceUsers } from "../../../service";

function FormProjectsData(props: any) {
  const { updateValue } = useFormStore();
  const { needSpinner } = useFormStore();
  const { token } = useAuthData();

  const [projectsList, setProjectsList] = useState([]);

  useEffect(() => {
    getProjects(props.id || "0");
  }, []);

  async function getProjects(id: string) {
    const data = await serviceUsers.getProjectsByUser(token, id);
    data.forEach((project) => {
      getClientName(project.projectId);
    });
  }

  async function getClientName(id: any) {
    const { project } = await serviceUsers.getProjectsById(token, id);
    const { name } = await serviceUsers.getClientById(token, project.clientId);

    const obj = {
      idProject: project.id,
      nameProject: project.name,
      nameClient: name,
    };

    setProjectsList((projectsList) => [...projectsList, obj]);
  }

  return (
    <Spinner status={needSpinner}>
      <div className="collaboratorContainer">
        <div className="title-form form-box-title">
          <h1 className="font-source-sans-pro align-self-end">Projetos alocados - {updateValue.name || "profissional"}</h1>
        </div>

        <Formik initialValues={updateValue} onSubmit={() => {}}>
          {(props) => (
            <form className="form-container box-form" onSubmit={props.handleSubmit}>
              {projectsList.length > 0 ? (
                <>
                  {projectsList.map((project, index) => {
                    return (
                      <>
                        <div className="row box-row" key={project.idProject}>
                          <InputFormik
                            className="form-input"
                            label={`Projeto ${index + 1}`}
                            name="beginnig_at"
                            onChange={() => {}}
                            value={project.nameProject}
                            placeholder=""
                            type="text"
                            required={false}
                            autofocus={false}
                            maxlength="10"
                            disabled
                          />
                          <InputFormik
                            className="form-input"
                            label={`Cliente ${index + 1}`}
                            name="beginnig_at"
                            onChange={() => {}}
                            value={project.nameClient}
                            placeholder=""
                            type="text"
                            required={false}
                            autofocus={false}
                            maxlength="10"
                            disabled
                          />
                        </div>
                      </>
                    );
                  })}
                </>
              ) : (
                <div className="row box-row">
                  <div className="nothing-list width-100">
                    <h1>Profissional ainda não tem projeto alocado</h1>
                  </div>
                </div>
              )}
            </form>
          )}
        </Formik>
      </div>
    </Spinner>
  );
}

export default FormProjectsData;
